module.exports = __webpack_public_path__ + "static/media/circle-check.baa4349b.svg";